"use client"

import { login } from "@/actions/auth"
import { useActionState } from "react"
import { signIn } from "next-auth/react"
import styles from "@/app/login/login.module.css"
import { useSearchParams } from "next/navigation"
import Link from "next/link"

export function LoginForm() {
    const searchParams = useSearchParams()
    const callbackUrl = searchParams.get("callbackUrl") || "/"
    const [state, formAction, isPending] = useActionState(login, undefined)

    return (
        <div className={styles.card}>
            <h2 className={styles.title}>Welkom terug</h2>
            <form action={formAction}>
                <input type="hidden" name="callbackUrl" value={callbackUrl} />
                <div className="mb-3">
                    <label htmlFor="email" className={styles.label}>
                        Email adres
                    </label>
                    <input
                        type="email"
                        className={styles.input}
                        id="email"
                        name="email"
                        required
                        placeholder="naam@voorbeeld.be"
                    />
                </div>
                <div className="mb-3">
                    <label htmlFor="password" className={styles.label}>
                        Wachtwoord
                    </label>
                    <input
                        type="password"
                        className={styles.input}
                        id="password"
                        name="password"
                        required
                        placeholder="••••••••"
                    />
                </div>
                {state?.error && (
                    <div className={styles.error}>{state.error}</div>
                )}
                <button
                    type="submit"
                    className={styles.button}
                    disabled={isPending}
                >
                    {isPending ? "Bezig met inloggen..." : "Inloggen"}
                </button>
            </form>

            <div className={styles.divider}>OF</div>

            <button
                className={styles.googleButton}
                onClick={() => signIn("google", { callbackUrl })}
            >
                <svg width="20" height="20" viewBox="0 0 24 24">
                    <path
                        fill="currentColor"
                        d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
                    />
                    <path
                        fill="currentColor"
                        d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
                    />
                    <path
                        fill="currentColor"
                        d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.26-.19-.58z"
                    />
                    <path
                        fill="currentColor"
                        d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
                    />
                </svg>
                Inloggen met Google
            </button>

            <div className={styles.footer}>
                Nog geen account?
                <Link href="/register" className={styles.link}>
                    Registreer hier
                </Link>
            </div>
        </div>
    )
}
